import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.div<{ $withLanguagePicker?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 11px 0;
  position: relative;
  width: 100vw;
  background-color: ${({ theme }) => theme.custom?.background || theme.colors.bodyBackground};
  color: ${({ theme }) => theme.custom?.bodyColor || theme.colors.bodyColor};
  z-index: 99;

  &::after {
    content: '';
    display: block;
    width: 100vw;
    height: 1px;
    background: ${({ theme }) => theme.custom?.headerBorder || '#d9ebf1'};
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  ${({ $withLanguagePicker }) =>
    $withLanguagePicker &&
    css`
      justify-content: flex-start;
      padding: 5px 16px;
    `}
`;

export const Logo = styled.div`
  width: 24px;
  height: 24px;
  background: url(${'/assets/images/logo.svg'}) center / contain no-repeat;
  ${({ theme }) => (theme.isRtl ? 'margin-left: 7px;' : 'margin-right: 7px;')}
`;

export const Text = styled.div`
  font-weight: 900;
  font-size: 18px;
  line-height: 19px;
`;

export const LanguageChip = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  ${({ theme }) => (theme.isRtl ? 'margin-right: auto;' : 'margin-left: auto;')}
  border: none;
  border-radius: 12px;
  background: transparent;
  color: inherit;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
`;

export const LanguageFlag = styled.img`
  width: 28px;
  height: 20px;
  border-radius: 3px;
  object-fit: cover;
`;
